import { ValidEmail, ValidEmailPayload } from '@dev/ee-api/ee-api-models';
import { AxiosPromise } from 'axios';
import { request } from './request';

export const loadValidEmails = (): AxiosPromise<ValidEmail[]> => {
    const { ValidEmails } = request();
    return ValidEmails.validemailsGet();
};
export const addValidEmail = (body: ValidEmailPayload): AxiosPromise<ValidEmail> => {
    const { ValidEmails } = request();
    return ValidEmails.validemailsPost(body);
};
export const deleteValidEmail = (email: string): AxiosPromise<void> => {
    const { ValidEmails } = request();
    return ValidEmails.validemailsByEmailDelete(email);
};
export const sendVerification = (body: ValidEmailPayload): AxiosPromise<void> => {
    const { ValidEmails } = request();
    return ValidEmails.validemailsVerificationPost(body);
};
